import './social_content_details_timestamp_view.js.coffee'
Namespace 'Monitoring.Views.SocialContents'

class Monitoring.Views.SocialContents.SocialContentDetailsSurveyTimestampView extends Monitoring.Views.SocialContents.SocialContentDetailsTimestampView
  _titleText: ->
    "#{I18n.t('surveys.dashboard.filters.answered_at')}: #{@timestamp.format 'DD/MM/YYYY HH:mmZ'}"
